$(function() {

  // slider continuo

  $('.carousel--infinite').each(function() {
    var $this = $(this),
        alignment = $(this).hasClass('carousel--left') || ($(window).width() <= 480) ? 'left' : 'center',
        grouping = $(this).hasClass('carousel--left') ? false : '97%';

    $this.flickity({
      pageDots: false,
      wrapAround: true,
      groupCells: grouping,
      prevNextButtons: !isMobile,
      arrowShape: arrowShape,
      // selectedAttraction: 0.013,
      // friction: 0.2,
      cellAlign: alignment
    });
  });

  // slider hero

  var navigable = ($('.hero .hero__item').length > 1) ? true : false;

  $('.hero').flickity({
    pageDots: false,
    wrapAround: true,
    prevNextButtons: navigable,
    // selectedAttraction: 0.013,
    // friction: 0.2,
    arrowShape: arrowShape
  });


  $('.carousel:not(.carousel--infinite)').each(function() {
    
    var $this = $(this),
        contW = $this.outerWidth(),
        itemW = $this.find('.carousel__item').outerWidth(),
        visibleItems = contW / itemW,
        navigable = ($this.find('.carousel__item').length > visibleItems && !$this.hasClass('carousel--dotted')) ? true : false,
        grouped = $this.hasClass('carousel--group') ? visibleItems : false,
        contain = grouped ? false : true,
        hasDots = $this.hasClass('carousel--dotted') ? true : false;

    $this.flickity({
      pageDots: hasDots,
      wrapAround: navigable,
      groupCells: grouped,
      cellAlign: 'left',
      draggable: true,
      prevNextButtons: navigable,
      arrowShape: arrowShape,
      // selectedAttraction: 0.013,
      // friction: 0.2,
      contain: contain
    });

  });

});
